import React, {memo} from 'react';
import ResponsiveLayout from './ResponsiveLayout';
import {useAuthLogic} from '@src/hooks/useAuthLogic';
import PropTypes from 'prop-types';
const HomeLayout = ({ children }) => {
  const { isInitialize } = useAuthLogic();
  return isInitialize ? <ResponsiveLayout>{children}</ResponsiveLayout> : null;
};

HomeLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default memo(HomeLayout);
